// extracted by mini-css-extract-plugin
export default {"containerData":"VentasDetail_containerData__KzGRV","containerDataRow":"VentasDetail_containerDataRow__G9TCq","contianerLoad":"VentasDetail_contianerLoad__g5DFC"};